var urank_options = {
    elem : {
        tagBoxRoot: '#tagbox',
        contentListRoot: '#contentlist',
        visCanvasRoot: '#viscanvas',
        tagCloudRoot: '#tagcloud',
        searchInputRoot: '#search-features'
    },
    dataAttr : {
        id : '_id',
        title : '_source.title',
        description : '_source.abstract'
    },
    features: {
        keywords: true,
        neighbors: false
    },
    dataConnector : {
        urls: {
            get_data: '',
            get_keywords: '',
            get_neighbors: '',
            urank: ''
        }
    },
    keywordExtractor: {
        useLocal: true,
        minDocFrequency: 2,
        minRepetitionsInDocument: 1,
        maxKeywordDistance: 3,
        minRepetitionsProxKeywords: 2
    },
    rankingModel: {
        useLocal : false
        // useLocal : true
    },
    tagCloud: {
        tagStyle: 'badge',
        highlight: 'body',
        // numCategories : 5,
        // minFontSize : 10,               // in px    
        // fontSizeGrowth: 0.15,           // minFontSize + fontSizeGrowth * keyword.score 
        aes: {
            hideScrollbar: false
        }
    },
    tagBox: {

    },
    docViewer: {
        attrToShow: [
            {
                attr: '_source.[authors].name', label: 'Authors', type: 'list'
            },{
                attr: '_source.URL', label: 'URL', type: 'url'
            }
        ] 
    },
    rankingRepresentation: {
        split_by: 'feature'                  // rs || feature
    },
    rankingModel: {
            rankBy: 'CB',
            rs : [
                {
                    name: 'CB',
                    active: true,
                    weight : 1.0,
                    attr : 'keywords',
                    pretty: 'Content Ranking'
                },{
                    name: 'CF',
                    active: false,
                    weight : 0,
                    attr : 'neighbors',
                    pretty: 'Social Ranking'
                }
            ]
        }
};

module.exports = urank_options;




//////////////////
// WEBPACK FOOTER
// ./js/urank_options.js
// module id = 247
// module chunks = 0